import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "MarketNavItemIcon",
  "use": "MarketNavItemIcon-usage",
  "viewBox": "0 0 23 24",
  "content": "<symbol viewBox=\"0 0 23 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"MarketNavItemIcon\">\n  <path d=\"M21.5863 4.56335H1.51172V14.7995H21.5863V4.56335Z\" stroke=\"currentcolor\" stroke-width=\"1.25\" />\n  <path d=\"M1.51465 23.4577V18.2102H21.5861V23.4577\" stroke=\"currentcolor\" stroke-width=\"1.25\" />\n  <path d=\"M1.51465 1.15259H21.5861\" stroke=\"currentcolor\" stroke-width=\"1.25\" stroke-linecap=\"square\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol